import React, { useState, useEffect, Fragment } from 'react'
import styled from 'styled-components'
import MediaQuery from 'react-responsive'
import DoubleQuotes from '../../../../public/images/homepage/icons/double-quotes.svg'
import { textTranslation, shouldTranslateTo } from '../utils/utils'

const Container = styled.div`
  position: relative;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`

const CarouselWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  gap: 30px;
`

const ArrowButton = styled.button`
  background-color: transparent;
  border-radius: 50px;
  width: 50px;
  height: 50px;
  border: 1px solid #000;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`

const CarouselImageWrapper = styled.div`
  margin: 0 10px;
  transition: all 0.5s ease-in-out;
`

const ArrowIcon = styled.img`
  width: 12px;
  rotate: ${({ iconRotate }) => (iconRotate ? '180deg' : '0deg')};
`

const TestimonialsCarouselDiv = styled.div`
  display: flex;
  /* background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(0,0,0,1) 50%, rgba(255,255,255,1) 100%); */
`

const TestimonialsCarouselItem = styled.div`
  width: -webkit-fill-available;
  height: 100%;
  min-height: 180px;
  background-color: transparent;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

const Text = styled.h5`
  color: #154549;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 21px;
  font-weight: 400;
  line-height: 143%;
  height: fit-content;
  margin-bottom: 10px;
  text-align: left;
`

const Name = styled.h5`
  color: #16494d;
  font-family: 'Open Sans', sans-serif;
  font-size: 25px;
  font-weight: 700;
  line-height: 140%;
  margin-right: 15px;

  @media screen and (max-width: 600px) {
    font-size: 18px;
  }
`

const Country = styled.h5`
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 140%;
`

const FlagDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 35px;

  img {
    width: 29px;
    height: 19px;
    margin-right: 10px;
  }
`

const CurrentInfo = styled.div`
  text-align: end;

  h5 {
    font-size: 18px;
    font-family: 'Open Sans', sans-serif !important;
  }
`

const TestimonialsCarouselV2 = ({}) => {
  const [currentIndex, setCurrentIndex] = useState(2)

  const [pageText, setPageText] = React.useState([])
  const [testimonials, setTestimonials] = React.useState([])

  React.useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          const testimonialsRaw = response.data.map((item) =>
            JSON.parse(item.text)
          )
          setTestimonials(testimonialsRaw)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('homepage-testimonial-v2', language)
  }, [])

  const handlePrevious = () => {
    const newIndex =
      currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1
    setCurrentIndex(newIndex)
  }

  const handleNext = () => {
    const newIndex = (currentIndex + 1) % testimonials.length
    setCurrentIndex(newIndex)
  }

  const setFlag = (text) => {
    var flagText = ''
    switch (text) {
      case ('france', 'frança'):
        flagText = 'france'
        break
      case ('netherlands', 'países_baixos'):
        flagText = 'netherlands'
        break
      case ('south_africa', 'áfrica_do_sul'):
        flagText = 'south_africa'
        break
      case ('uk', 'reino_unido'):
        flagText = 'uk'
        break
      case ('usa', 'eua'):
        flagText = 'usa'
        break
      case ('australia', 'austrália'):
        flagText = 'australia'
        break
      default:
        flagText = text
    }
    return flagText
  }

  const getTestimonialsDisplay = () => {
    const total = testimonials.length
    let divs = []

    for (let i = 0; i <= 0; i++) {
      let index = (currentIndex + i + total) % total
      let flag = setFlag(
        testimonials[index].country.replace(/\s+/g, '_').toLowerCase()
      )
      divs.push(
        <CarouselImageWrapper key={index}>
          <TestimonialsCarouselItem>
            <FlagDiv>
              <Name>{testimonials[index].name}</Name>
              <img
                src={'/images/languages/' + flag + '.svg'}
                alt={testimonials[index].country}
                className="flag"
              />
              <Country>{testimonials[index].country}</Country>
            </FlagDiv>

            <div>
              <Text
                dangerouslySetInnerHTML={{
                  __html: testimonials[index].text,
                }}
              ></Text>
            </div>
          </TestimonialsCarouselItem>
        </CarouselImageWrapper>
      )
    }
    return divs
  }

  return (
    <div>
      {testimonials && testimonials.length > 0 ? (
        <Container>
          <TestimonialsCarouselDiv>
            {getTestimonialsDisplay()}
          </TestimonialsCarouselDiv>

          <CarouselWrapper>
            <ArrowButton onClick={handlePrevious}>
              <ArrowIcon
                src="/images/homepage/icons/arrow-line-bk.svg"
                alt="arrow left"
              />
            </ArrowButton>

            <CurrentInfo>
              {
                <h5>
                  <b>{currentIndex + 1}</b> / {testimonials.length}
                </h5>
              }
            </CurrentInfo>

            <ArrowButton onClick={handleNext}>
              <ArrowIcon
                src="/images/homepage/icons/arrow-line-bk.svg"
                alt="arrow right"
                iconRotate
              />
            </ArrowButton>
          </CarouselWrapper>
        </Container>
      ) : (
        ''
      )}
    </div>
  )
}

export default TestimonialsCarouselV2
